import { render, staticRenderFns } from "./button_group.vue?vue&type=template&id=40f39906&"
import script from "./button_group.vue?vue&type=script&lang=js&"
export * from "./button_group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports